<div class="row title">
  <div class="col-lg-10 col-md-10 col-sm-10"><h3>Dashboard / <span>SMS logs</span></h3></div>
  <div class="col-lg-2 col-md-2 col-sm-2"><button class="openDesignToolBtn"><a href="http://house.infurnia.com/" target="_blank" class="pull-right" style="text-decoration: none;color: black;" *ngIf="role && (role=='designer' || role=='admin') ">Open  Design Tool</a></button></div>
</div>

<!-- customers table starts-->
<div class="row body_height justify-content-center">
  <div class="col-12" *ngIf="successalert">
    <div class="alert-box grid-100" *ngIf="successMessage">
      <div class="alert alert-success mt-3 text-center">
          <a class="close link" data-dismiss="alert"  (click)="successalert=false">×</a>
          {{successMessage}}
        </div>
    </div>
  </div>
  <div class="col-12" *ngIf="erroralert">
    <div class="alert-box grid-100" *ngIf="errorMessage">
      <div class="alert alert-success mt-3 text-center">
          <a class="close link" data-dismiss="alert"  (click)="erroralert=false">×</a>
          {{errorMessage}}
        </div>
    </div>
  </div>
  <div class="col-12 table-responsive p-0">
    <div *ngIf="smsLogs && smsLogs.length == 0" class="text-center my-5">No Lead with status {{customer_status | replaceChar}} !</div>
    <table class="table table-hover" *ngIf="smsLogs && smsLogs.length != 0">
      <thead>
        <tr>
          <th>Type</th>
          <th>Sent</th>
          <th>Body</th>
          <th>Delivered</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor=" let obj of smsLogs">
          <td>{{obj.sms_type}}</td>
          <td>{{obj.sms_sent}}</td>
          <td>{{obj.sms_body}}</td>
          <td>{{obj.sms_delivered}}</td>
          <td>{{obj.sms_status}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<!-- customers table ends-->


// WEBPACK FOOTER //
// ./src/app/sms-logs/sms-logs.component.html